import { gql } from '@apollo/client';

// Split out of the now-deleted DealCard.tsx (ENG-3633): the DealCard
// component itself had zero importers, but these fragments are live --
// consumed by features/deals/Executed/index.tsx, features/deals/InProgress/
// index.tsx, and query/SellerDealsWithCarves.ts.
export const DealCardFragments = {
  deal: gql`
    fragment DealCardDeal on Deal {
      id
      createdDate: created_date
      state {
        status
        blocker
        label
        tooltip
        loanDataVisible
      }
      listing {
        id
        name
        assetClass: asset_class
        upb: t_current_balance_cents
        wac: wa_coupon_bps
        providedName: name
      }
      hasNewMessages: has_new_messages
    }
  `,
  counterparty: gql`
    fragment DealCardCounterparty on Company {
      __typename
      type
      ... on PrivateCompany {
        id
        name
      }
    }
  `,
};
